/**
 * Human-readable names for the silhouette's parts, per view.
 *
 * Authored here rather than copied: the geometry ships part KEYS
 * (`leftShoulder`, `abdomen`) and no labels, so these are ours.
 *
 * Labels are PER VIEW, and that is the whole reason this file is a nested map
 * rather than a flat one. The artwork reuses `upperBody`, `abdomen` and
 * `pelvis` for both drawings, but on a back they are the upper back, the lower
 * back and the buttocks. Labelling the back's `abdomen` "Abdomen" would point a
 * clinician at the wrong side of a person — the same class of mistake the
 * licensed source made when it called the groin the abdomen.
 *
 * `left` and `right` are the PERSON'S, which is why they read "patient left"
 * rather than "left". Proven in geometry/__tests__/bodyGeometry.test.js: on the
 * front view the person's left is drawn to the viewer's right, and on the back
 * view to the viewer's left.
 */

const limbs = {
  leftShoulder: 'Shoulder (patient left)',
  rightShoulder: 'Shoulder (patient right)',
  leftUpperArm: 'Upper arm (patient left)',
  rightUpperArm: 'Upper arm (patient right)',
  leftLowerArm: 'Forearm (patient left)',
  rightLowerArm: 'Forearm (patient right)',
  leftHand: 'Hand (patient left)',
  rightHand: 'Hand (patient right)',
  leftUpperLeg: 'Thigh (patient left)',
  rightUpperLeg: 'Thigh (patient right)',
  leftLowerLeg: 'Lower leg (patient left)',
  rightLowerLeg: 'Lower leg (patient right)',
  leftFoot: 'Foot (patient left)',
  rightFoot: 'Foot (patient right)',
};

export const BODY_AREA_LABELS = {
  front: {
    ...limbs,
    head: 'Face',
    neck: 'Neck',
    upperBody: 'Chest',
    abdomen: 'Abdomen',
    pelvis: 'Bikini line',
    leftKnee: 'Knee (patient left)',
    rightKnee: 'Knee (patient right)',
  },
  back: {
    ...limbs,
    head: 'Scalp',
    neck: 'Nape',
    upperBody: 'Upper back',
    abdomen: 'Lower back',
    pelvis: 'Buttocks',
    leftElbow: 'Elbow (patient left)',
    rightElbow: 'Elbow (patient right)',
  },
};

/** The label for a part in a view, or the raw key if we have not named it. */
export function labelFor(view, key) {
  return (BODY_AREA_LABELS[view] || {})[key] || key;
}
